"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Day = void 0;
var React = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Button = require("../Button");
var _Text = require("../Text");
var _DayModule = _interopRequireDefault(require("./Day.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// $FlowFixMe[untyped-import]
// $FlowFixMe[untyped-import]
const getTextColor = (disabled, filled) => {
  if (disabled) {
    return _Text.TEXT_COLORS.disabled;
  } else if (filled) {
    return _Text.TEXT_COLORS.inversePrimary;
  } else {
    return _Text.TEXT_COLORS.secondary;
  }
};
const Day = _ref => {
  let {
    date,
    value,
    filled,
    onHover,
    onClick,
    disabled,
    hoverDay,
    outlined,
    endOfRange,
    highlighted,
    startOfRange
  } = _ref;
  return /*#__PURE__*/React.createElement(_Button.UnstyledButton, {
    tabIndex: disabled ? -1 : 0,
    className: (0, _classify.default)(_DayModule.default.calendarItemButton, {
      [_DayModule.default.calendarRowItemDisabled]: disabled,
      [_DayModule.default.calendarRowItemHighlighted]: !disabled && (highlighted || startOfRange || endOfRange)
    }),
    onMouseOver: onHover,
    onClick: onClick,
    onKeyUp: onHover
  }, /*#__PURE__*/React.createElement(_Text.BodyMedium, {
    type: "ghost",
    color: getTextColor(disabled, filled),
    className: (0, _classify.default)(_DayModule.default.calendarRowItem, {
      [_DayModule.default.calendarRowItemHover]: !disabled && _moment.default.utc(date).isSame(hoverDay),
      [_DayModule.default.calendarRowItemFilled]: !disabled && filled,
      [_DayModule.default.calendarRowItemOutlined]: outlined
    })
  }, value));
};
exports.Day = Day;